<template>
  <div v-if="isTermsAccepted()">
    <span class="text--secondary text-body-2">
      {{ $t('DASHBOARD.REGISTRATION') }}: {{ getRegisterDate() }}
    </span>
  </div>
  <div v-else>
    <language-select
      item-text="name"
      item-value="id"
      class="pt-0"
      hide-details="auto"
      :label="$t('BUTTON.EXPORT_WELCOME_LETTER')"
      @change="downloadPdf"
    />
  </div>
</template>

<script>
import LanguageSelect from '@/modules/_global/_components/LanguageSelect.vue';
import { PersonsService } from '@/services/persons.service';
import downloadFile from '@/modules/_global/mixins/download-file';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'WelcomeLetter',
  components: { LanguageSelect },

  mixins: [downloadFile],

  props: {
    user: Object,
    firstName: String,
    lastName: String,
    personId: Number
  },

  methods: {
    isTermsAccepted() {
      return Boolean(this.user.terms_accepted_at);
    },

    getRegisterDate() {
      return dateFormat(this.user.terms_accepted_at);
    },

    getFileName() {
      const fileName = this.$t('PERSONS.WELCOME_LETTER_FILE');
      return fileName + ` ${this.firstName} ${this.lastName}.pdf`;
    },

    downloadPdf(languageId) {
      PersonsService.getWelcomeLetterPdf(this.personId, {
        language: languageId
      }).then(response => {
        this.downloadFile(
          response,
          this.getFileName()
        );
      });
    }
  }
}
</script>
